import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import BotaoPadrao from "../../../components/botao-padrao";

const RelatorioResultados = () => {
  const { state } = useLocation();
  const dados = state?.resultados || [];
  const tipo = state?.tipo_agrupamento;
  const navigate = useNavigate();
  const imprimir = () => window.print();

  if (!dados.length) {
    return (
      <div className="formContainer">
        <h2 className="titulo">Nenhum resultado encontrado</h2>
      </div>
    );
  }

  const candidatos = dados[0].candidatos;

  const labelTipo = {
    local_votacao: "Locais de Votação",
    zona: "Zonas",
    municipio: "Municípios",
  }[tipo];

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <BotaoPadrao label="Imprimir / Exportar PDF" onClick={imprimir} />
        <BotaoPadrao label="Voltar" onClick={() => navigate("/relatorios")} />
      </div>

      <div className={styles.pagina}>
        <h1 className="titulo">Relatório de Resultados</h1>
        <h2 className={styles.subtitulo}>Tipo: {labelTipo}</h2>
      </div>

      {tipo === "local_votacao" &&
        dados.map((municipio, i) => (
          <div key={i}>
            {municipio.zonas.map((zona, z) => {
              const totais = {};
              candidatos.forEach((c) => (totais[c] = 0));

              zona.locais.forEach((loc) => {
                candidatos.forEach((c) => {
                  totais[c] += Number(loc.votos[c] || 0);
                });
              });

              return (
                <div className={styles.pagina} key={z}>
                  <h2 className={styles.tituloGrupo}>
                    Município: {municipio.nome_municipio}
                  </h2>
                  <h3 className={styles.subGrupo}>Zona: {zona.numero_zona}</h3>

                  <table className={styles.tabela}>
                    <thead>
                      <tr>
                        <th>Local</th>
                        <th>Endereço</th>
                        <th>Bairro</th>
                        {candidatos.map((c) => (
                          <th key={c}>{c}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {zona.locais.map((loc, idx) => (
                        <tr key={idx}>
                          <td>{loc.nome_local_votacao}</td>
                          <td>{loc.endereco_local_votacao}</td>
                          <td>{loc.bairro_local_votacao}</td>

                          {candidatos.map((c) => (
                            <td key={c}>{loc.votos[c] ?? 0}</td>
                          ))}
                        </tr>
                      ))}

                      <tr className={styles.totalRow}>
                        <td colSpan={3} className={styles.totalLabel}>
                          Total da Zona
                        </td>
                        {candidatos.map((c) => (
                          <td key={c} className={styles.totalValue}>
                            {totais[c]}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        ))}

      {tipo === "zona" &&
        dados.map((municipio, m) => (
          <div className={styles.pagina} key={m}>
            <h2 className={styles.tituloGrupo}>
              Município: {municipio.nome_municipio}
            </h2>

            <table className={styles.tabela}>
              <thead>
                <tr>
                  <th>Zona</th>
                  {candidatos.map((c) => (
                    <th key={c}>{c}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {municipio.zonas.map((zona, z) => (
                  <tr key={z}>
                    <td>{zona.numero_zona}</td>

                    {candidatos.map((c) => (
                      <td key={c}>{zona.votos[c] ?? 0}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

      {tipo === "municipio" &&
        dados.map((municipio, idx) => (
          <div className={styles.pagina} key={idx}>
            <h2 className={styles.tituloGrupo}>
              Município: {municipio.nome_municipio}
            </h2>

            <table className={styles.tabela}>
              <thead>
                <tr>
                  <th>Município</th>
                  {candidatos.map((c) => (
                    <th key={c}>{c}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{municipio.nome_municipio}</td>

                  {candidatos.map((c) => (
                    <td key={c}>{municipio.votos[c] ?? 0}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        ))}
    </div>
  );
};

export default RelatorioResultados;
